import * as React from "react";
import { useRegistrationContext } from "../Contexts/RegistrationContext";
import { Checkbox } from "../Elements/Checkbox";
import "./ConditionsForm.scss";

export const ConditionsForm = (): JSX.Element => {
    const { setConditionAgreed } = useRegistrationContext();

    return (
        <div className="conditions-form">
            <strong className="conditions-label">
                Ar cirsmas izstrādi saistīto darbību (sortimentu pievešana, nokraušana, transportēšana u.c. turpmāk -
                Darbība) LVM meža zemē un/vai meža ceļu izmantošanu drīkst uzsākt saņemot rakstisku LVM saskaņojumu uz
                elektroniskā pasta adresi vai pēc Vienošanās noslēgšanas.
            </strong>
            <ul>
                <li>
                    Kokmateriālu pievešanu veikt tikai pa dabā esošiem pievešanas ceļiem vai brauktuvēm tam piemērotos
                    laika apstākļos. Kokmateriālu izvedējtehnikai nepārvietoties pa meža autoceļiem.
                </li>
                <li>
                    Kokmateriālu pievešanas un nokraušanas laikā nebojāt augošus kokus, un ceļa sāngrāvjus vai nogāzes.
                </li>
                <li>
                    Pēc darbu pabeigšanas veikt pievešanas ceļu, krautuves vietas sakārtošanu, nolīdzināt izveidojušos
                    augsnes bojājumus (risas), sakārtot ceļa infrastruktūru.
                </li>
                <li>
                    Meža autoceļus kokmateriālu transportēšanai izmantot tikai piemērotos (sausuma vai sasaluma) laika
                    apstākļos, neradot bojājumus un ievērojot noteikumus par maksimālo pieļaujamo svaru kokvedēja
                    transportam. Pēc katras kokvedēju mašīnas uzkraušanās no meža ceļa novākt ciršanas atliekas.
                </li>
                <li>
                    Pirms transportēšanas uzsākšanas pārliecināties par meža ceļa pieejamību, izmantojot LVM publiskajos
                    datos (Kartes - LVM GEO, LVM GEO mobilā aplikācija) pieejamo informāciju par LVM ceļu
                    aprobežojumiem.
                </li>
                <li>
                    Saglabāt medību infrastruktūru (medību torņi, dzīvnieku barotavas, tilti, laipas), informēt LVM
                    kontaktpersonu, ja izvietotā medību infrastruktūra traucē darbu izpildi.
                </li>
                <li>
                    Nekavējoties informēt LVM kontaktpersonu, ja darbības laikā meža zemei vai meža infrastruktūras
                    objektam vai meža autoceļam radīti bojājumi un vienoties par turpmāko rīcību.
                </li>
                <li>
                    Darbības veicējs pilnībā uzņemas atbildību, tai skaitā zaudējumu atlīdzināšanu, par meža zemes un
                    meža infrastruktūras objektu, tsk. meža autoceļu izmantošanas laikā radītajiem bojājumiem vai
                    zaudējumiem LVM, kas radušies darbības rezultātā vai normatīvo aktu pārkāpumu rezultātā, tanī skaitā
                    par pārkāpumiem, ko veikušas piesaistītas trešās personas vai apakšuzņēmēji.
                </li>
                <li>
                    Ja tiks konstatēts, ka darbības rezultātā radīti bojājumi augošiem kokiem, LVM aprēķinās zaudējumus
                    EUR 70.00 (septiņdesmit euro 00 centu) apmērā, par katru bojāto koku, kas jāsedz personai, kura veic
                    saskaņotās darbības.
                </li>
                <li>
                    Ja veikto darbu gaitā tiek bojāta vai iznīcināta kāda no robežzīmēm, darbības veicējs to atjauno
                    atbilstoši Ministru kabineta noteikumiem Nr.1019 “Zemes kadastrālās uzmērīšanas noteikumi” par
                    saviem līdzekļiem.
                </li>
                <li>
                    Pēc darbības pabeigšanas, ne vēlāk kā 3 dienu laikā, informēt LVM kontaktpersonu par darbu
                    pabeigšanu.
                </li>
                <li>
                    Ja laikapstākļu dēļ LVM ir noteikusi pārvietošanās ierobežojumus meža autoceļiem, tai skaitā, ja
                    risu izlīdzināšanu nav bijis iespējams tehniski veikt meža ceļa stāvokļa dēļ, tad attiecīgā meža
                    autoceļa un/vai meža zemes (kokmateriālu pievešanas vietas), kā arī krautuves vietas labošanas
                    darbi, saskaņojot ar LVM kontaktpersonu, uzsākami 30 dienu laikā pēc darbības pabeigšanas. Risas
                    aizlīdzināmas divu nedēļu laikā pēc ierobežojumu atcelšanas vai pēc meža autoceļa tehniskā stāvokļa
                    uzlabošanās.
                </li>
                <li>
                    Laika periodā, kad Valsts meža dienests ir noteicis meža ugunsnedrošo laikposmu, jāievēro maksimāla
                    piesardzība un jārīkojas atbilstoši Ministru kabineta 19.04.2016. noteikumu Nr.238 “Ugunsdrošības
                    noteikumi” prasībām, kas attiecas uz uzturēšanos mežā. LVM aicina izvairīties no jebkādas atklātas
                    liesmas veidošanas mežā vai tiešā tā tuvumā, vai veikt jebkuru citu darbību, kas var izraisīt
                    ugunsgrēku.
                </li>
                <li>
                    Tiešo kontroli par LVM prasību ievērošanu veic LVM kontaktpersona, vispārējo kontroli par normatīvo
                    aktu noteikumu ievērošanu ir tiesības veikt jebkuram LVM darbiniekam. Nosacījumu neievērošanas
                    gadījumā, LVM kontaktpersonai ir tiesības pieprasīt Darbības meža zemē un meža infrastruktūras
                    objektos pārtraukšanu un Darbības vietas sakārtošanu sākotnējā stāvoklī.
                </li>
            </ul>
            <Checkbox
                label={"Apņemos ievērot nosacījumus"}
                defaultChecked={false}
                required={true}
                onChange={setConditionAgreed}
            ></Checkbox>
        </div>
    );
};
